module.exports = __webpack_public_path__ + "img/oguri_kimono_salon_SC.4cdd3720.jpg";